<template>
  <div class="annual-weighing-container">
    <AnnualWeighingFilter
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import GeneratorPage from 'src/modules/generator/generator/GeneratorPage.vue'
import AnnualWeighingFilter from './components/AnnualWeighingFilter.vue'

const { CrudLayout, modal } = JtCrud

@Component({
  name: 'annualWeighing',
  components: {
    CrudLayout,
    GeneratorPage,
    'detail-modal': modal,
    AnnualWeighingFilter
  }
})
class AnnualWeighing extends Vue {

}
export default AnnualWeighing
</script>
<style lang="stylus" scoped></style>
